import NavTurista from "@/components/itly/NavTurista";
import HeroTurista from "@/components/itly/HeroTurista";
import ExploreItly from "@/components/itly/ExploreItly";
import ItalyMap from "@/components/itly/ItalyMap";
import TryItly from "@/components/itly/TryItly";
import SchedaPreview from "@/components/itly/SchedaPreview";
import Manifesto from "@/components/itly/Manifesto";
import EsploratoreBadge from "@/components/itly/EsploratoreBadge";
import WaitlistForm from "@/components/itly/WaitlistForm";
import PartnerBridge from "@/components/itly/PartnerBridge";
import Footer from "@/components/itly/Footer";
import CursorSpark from "@/components/itly/CursorSpark";
import SectionNav from "@/components/itly/SectionNav";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { useTrackPageView } from "@/hooks/useAnalytics";

const SECTIONS = [
    { id: "inizio", labelKey: "sections.start" },
    { id: "esplora", labelKey: "sections.explore" },
    { id: "mappa", labelKey: "sections.map" },
    { id: "prova", labelKey: "sections.try" },
    { id: "scheda-preview", labelKey: "sections.card" },
    { id: "manifesto", labelKey: "sections.manifesto" },
    { id: "esploratore", labelKey: "sections.badge" },
    { id: "waitlist", labelKey: "sections.waitlist" },
];

export default function HomeTurista() {
    useScrollReveal();
    useTrackPageView("/");
    return (
        <div
            data-testid="home-turista"
            className="itly-page-root"
            style={{ background: "var(--itly-page)", minHeight: "100vh" }}
        >
            <CursorSpark />
            <NavTurista />
            <SectionNav items={SECTIONS} />
            <HeroTurista />
            <ExploreItly />
            <ItalyMap />
            <TryItly />
            <SchedaPreview />
            <Manifesto />
            <EsploratoreBadge />
            <WaitlistForm />
            <PartnerBridge />
            <Footer />
        </div>
    );
}
